import { render, staticRenderFns } from "./PushwizeView.vue?vue&type=template&id=33094e68&"
import script from "./PushwizeView.vue?vue&type=script&lang=js&"
export * from "./PushwizeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports